import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closePopup } from '../../Modal/action';
import './style.scss';


const EkycValidateModal = (props) => {

    const {closePopup, okAction, kycData } = props;

    const onClick = () =>{
        closePopup();
        okAction();
    }

    const onSubmitKycForm = () => {
        var form = document.getElementById("ekycForm");
        form.submit();
    }

    return (
        <div>
            <div className='popupOuter'>
                <div className='popupSec' style={{textAlign: 'center'}}>
                    {kycData.registrationType == 'NEW' && kycData.kycStatus == 'NOT_VALIDATED' ?
                    <div>
                        <h4 className='message'>Your KYC Status is 'Registered'. <a href='javascript:void(0)' onClick={onSubmitKycForm}>Click here</a> to initiate update KYC process to change KYC status to 'Validated'</h4>
                    </div>:
                    <div>
                        <h4 className='message'>Your KYC Status is 'On hold'. <a href='javascript:void(0)' onClick={onSubmitKycForm}>Click here</a> to initiate modify KYC process to change KYC status to 'Validated'</h4>
                    </div>
                    }
                    <button className='ok-button' onClick={onClick}>OK</button>
                </div>
                {kycData.ekycRequestCO && 
                <form autocomplete="off" name='ekycForm' id="ekycForm" method='POST' enctype="multipart/form-data" action={kycData.ekycRequestCO.camsUrl}>
                    <input id="url" type="hidden" name="url" value={kycData.ekycRequestCO.url}/>
                    <input id="sess_id" type="hidden" name="sess_id" value={kycData.ekycRequestCO.sess_id} />
                    <input id="ekyctype" type="hidden" name="ekyctype" value={kycData.ekycRequestCO.ekyctype} />
                    <input id="Plkyc_type" type="hidden" name="Plkyc_type" value={kycData.ekycRequestCO.plkyc_type} />
                    <input id="kyc_data" type="hidden" name="kyc_data" value={kycData.ekycRequestCO.kyc_data} />
                </form>}
            </div>
            <div className='popup_overlay black_overlay' />
        </div>
    );

}

const mapDispatchToProps = (dispatch) => ({
    closePopup: bindActionCreators(closePopup, dispatch),
});

export default connect('',mapDispatchToProps)(EkycValidateModal);
